import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '@/shared/helpers';

function stripHtml(html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

export const COLUMNS = [
    {
        Header: "ID",
        accessor: "id",
        width: 50,
    },
    {
        Header: "Domain Name",
        accessor: "domain.name",
        Cell: ({ row, value }) => <Link to={`/banner-status/view/${row.original.id}`}>{value}</Link>,
    },
    {
        Header: "Banner Text",
        accessor: "banner_status",
        Cell: ({ value }) => stripHtml(value),
    },
    {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ value }) => formatDate(value),
    }
];
